import { TabPageDefinition } from '@/components/tab-pages.js';

type AvailableStudentGroupsTabs = 'Active student groups' | 'Pending reassignment';

export const studentGroupsTabs = (selectedTab?: AvailableStudentGroupsTabs): TabPageDefinition[] => [
  {
    label: 'Active student groups',
    linkProps: {
      to: '/student-groups',
    },
    isSelectedTab: selectedTab === 'Active student groups' || !selectedTab,
  },
  {
    label: 'Pending reassignment',
    linkProps: {
      to: '/student-groups/pending-reassignment',
    },
    isSelectedTab: selectedTab === 'Pending reassignment',
  },
];
